import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";

export default function CTASection() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#EBF4FA] to-[#FFEFEA]" data-testid="cta-section">
      {/* faint blueprint building line-art */}
      <div className="absolute right-0 bottom-0 w-1/2 h-full opacity-[0.07] pointer-events-none">
        <svg viewBox="0 0 400 300" className="w-full h-full" fill="none" stroke="#0A192F" strokeWidth="1">
          <rect x="180" y="60" width="140" height="220" />
          <rect x="120" y="120" width="60" height="160" />
          {[...Array(9)].map((_, i) => <line key={i} x1="180" y1={80 + i * 22} x2="320" y2={80 + i * 22} />)}
          {[...Array(5)].map((_, i) => <line key={i} x1={200 + i * 24} y1="60" x2={200 + i * 24} y2="280" />)}
        </svg>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 relative">
        <Reveal>
          <Label>Let's Work Together</Label>
          <h2 className="font-heading text-4xl md:text-6xl uppercase font-bold text-navy tracking-tight mt-4 max-w-2xl leading-[0.95]">
            Have a project in mind?
          </h2>
          <p className="mt-6 text-lg text-navy/70 max-w-xl leading-relaxed">
            We'd love to hear about your project and explore how we can help you achieve high performance building outcomes.
          </p>
          <Link
            to="/contact"
            data-testid="cta-get-in-touch"
            className="group inline-flex items-center gap-3 mt-9 bg-brand text-white px-8 py-4 text-xs tracking-[0.18em] uppercase font-bold hover:bg-navy transition-colors"
          >
            Get In Touch
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
